export default defineNuxtPlugin(async (nuxtApp) => {
    const currentYearStore = useCurrentYearStore()
    
    // Получаем локаль из URL
    const locale = process.client 
        ? window.location.pathname.split('/')[1] || 'en'
        : 'en'
    
    try {
        await currentYearStore.fetchCurrentYear(locale, nuxtApp.$apiFetch)
    } catch (error) {
        console.error('Failed to initialize current year:', error)
    }
})
